/* TRIMSOUL — theme.js. Vanilla JS, no jQuery, no build step.
   All motion is disabled under prefers-reduced-motion. */
(function () {
  'use strict';

  var TS = (window.TS = window.TS || {});
  var CFG = window.TS_THEME || {};
  var STR = CFG.strings || {};
  var reduceMQ = window.matchMedia('(prefers-reduced-motion: reduce)');
  /* shop.money_format arrives as e.g. "Rs. {amount}" with the placeholder wrapped in
     doubled braces. The delimiters are assembled from char codes so this asset file
     contains no Liquid-looking sequences at all. */
  var BRACE_L = String.fromCharCode(123);
  var BRACE_R = String.fromCharCode(125);
  var MONEY_PLACEHOLDER = new RegExp(BRACE_L + BRACE_L + '[^' + BRACE_R + ']*' + BRACE_R + BRACE_R, 'g');
  var moneyFormat = CFG.moneyFormat || '₹' + BRACE_L + BRACE_L + 'amount' + BRACE_R + BRACE_R;

  /* ---------- tiny helpers ---------- */
  function qs(sel, root) { return (root || document).querySelector(sel); }
  function qsa(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }
  function on(el, ev, fn, opts) { if (el) { el.addEventListener(ev, fn, opts || false); } }
  function reduced() { return reduceMQ.matches; }

  /* INR, no decimals, thousands separated: Rs. 2,999 */
  function formatMoney(cents) {
    var value = (cents / 100).toFixed(2);
    var grouped = value.split('.')[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    if (MONEY_PLACEHOLDER.test(moneyFormat)) {
      MONEY_PLACEHOLDER.lastIndex = 0;
      return moneyFormat.replace(MONEY_PLACEHOLDER, grouped);
    }
    return moneyFormat + grouped;
  }

  function debounce(fn, wait) {
    var t;
    return function () {
      var args = arguments, self = this;
      clearTimeout(t);
      t = setTimeout(function () { fn.apply(self, args); }, wait);
    };
  }

  function isEmail(value) { return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value); }
  /* ---------- focus trap ---------- */
  var FOCUSABLE = 'a[href], button:not([disabled]), input:not([disabled]):not([type="hidden"]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';
  function trapFocus(container) {
    function handler(e) {
      if (e.key !== 'Tab') { return; }
      var items = qsa(FOCUSABLE, container).filter(function (el) { return el.offsetParent !== null; });
      if (!items.length) { return; }
      var first = items[0], last = items[items.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }
    container.addEventListener('keydown', handler);
    return function () { container.removeEventListener('keydown', handler); };
  }
  /* ---------- scroll lock ---------- */
  var lockCount = 0;
  function lockScroll() {
    lockCount += 1;
    document.body.classList.add('ts-noscroll');
    var target = headerTarget();
    if (target) { target.classList.remove('ts-hide'); }
  }
  function unlockScroll() { lockCount = Math.max(0, lockCount - 1); if (!lockCount) { document.body.classList.remove('ts-noscroll'); } }
  /* ---------- header: hide on scroll down, show on scroll up ---------- */
  function headerTarget() {
    var header = qs('[data-ts-header]');
    if (!header) { return null; }
    return header.closest('.ts-sticky-header') || header.closest('.shopify-section') || header;
  }

  function initHeaderScroll() {
    var target = headerTarget();
    if (!target) { return; }
    var last = window.pageYOffset;
    var ticking = false;
    function update() {
      var y = window.pageYOffset;
      if (y > last && y > 140 && !document.body.classList.contains('ts-noscroll')) {
        target.classList.add('ts-hide');
      } else if (y < last) {
        target.classList.remove('ts-hide');
      }
      last = y;
      ticking = false;
    }
    on(window, 'scroll', function () {
      if (!ticking) { ticking = true; window.requestAnimationFrame(update); }
    }, { passive: true });
  }
  /* ---------- mobile menu ---------- */
  function initMobileMenu() {
    var menu = qs('[data-ts-mobile-menu]');
    var openers = qsa('[data-ts-menu-open]');
    if (!menu || !openers.length) { return; }
    var untrap = null;
    function open() {
      menu.setAttribute('data-open', 'true');
      menu.removeAttribute('aria-hidden');
      openers.forEach(function (b) { b.setAttribute('aria-expanded', 'true'); });
      lockScroll();
      var close = qs('[data-ts-menu-close]', menu);
      if (close) { close.focus(); }
      untrap = trapFocus(menu);
    }
    function close() {
      menu.setAttribute('data-open', 'false');
      menu.setAttribute('aria-hidden', 'true');
      openers.forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
      unlockScroll();
      if (untrap) { untrap(); untrap = null; }
    }
    openers.forEach(function (b) { on(b, 'click', open); });
    qsa('[data-ts-menu-close]', menu).forEach(function (b) { on(b, 'click', close); });
    on(document, 'keydown', function (e) { if (e.key === 'Escape' && menu.getAttribute('data-open') === 'true') { close(); } });
    /* glitch flash on tap */
    qsa('a', menu).forEach(function (a) {
      on(a, 'touchstart', function () { a.classList.add('ts-anim-shake'); setTimeout(function () { a.classList.remove('ts-anim-shake'); }, 400); }, { passive: true });
    });
  }
  /* ---------- search overlay + predictive search ---------- */
  function initSearch() {
    var overlay = qs('[data-ts-search]');
    var openers = qsa('[data-ts-search-open]');
    if (!overlay || !openers.length) { return; }
    var input = qs('[data-ts-search-input]', overlay);
    var results = qs('[data-ts-search-results]', overlay);
    var untrap = null;

    function open() {
      overlay.setAttribute('data-open', 'true');
      overlay.removeAttribute('aria-hidden');
      openers.forEach(function (b) { b.setAttribute('aria-expanded', 'true'); });
      lockScroll();
      if (input) { input.focus(); input.select(); }
      untrap = trapFocus(overlay);
    }
    function close() {
      overlay.setAttribute('data-open', 'false');
      overlay.setAttribute('aria-hidden', 'true');
      openers.forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
      unlockScroll();
      if (untrap) { untrap(); untrap = null; }
    }
    openers.forEach(function (b) { on(b, 'click', open); });
    qsa('[data-ts-search-close]', overlay).forEach(function (b) { on(b, 'click', close); });
    on(document, 'keydown', function (e) { if (e.key === 'Escape' && overlay.getAttribute('data-open') === 'true') { close(); } });

    if (!input || !results) { return; }

    var render = function (json) {
      var products = (json.resources && json.resources.results && json.resources.results.products) || [];
      if (!products.length) {
        results.innerHTML = '<p class="ts-search__hint">' + (STR.noResults || 'NOTHING FOUND. TRY ANOTHER WORD.') + '</p>';
        return;
      }
      var html = '<p class="ts-search__hint">' + (STR.products || 'PRODUCTS') + '</p><ul>';
      products.forEach(function (p) {
        var img = p.featured_image && p.featured_image.url ? '<img src="' + p.featured_image.url + '" alt="" width="64" height="80" loading="lazy">' : '<span class="ts-search__result-img"></span>';
        html += '<li class="ts-search__result"><a href="' + p.url + '">' + img + '</a>' +
          '<h4><a href="' + p.url + '">' + p.title + '</a></h4>' +
          '<span class="ts-price">' + (p.price || '') + '</span></li>';
      });
      html += '</ul>';
      results.innerHTML = html;
    };

    var search = debounce(function () {
      var term = input.value.trim();
      if (term.length < 2) { results.innerHTML = ''; return; }
      var url = (CFG.routesPredictive || '/search/suggest') + '?q=' + encodeURIComponent(term) +
        '&resources[type]=product&resources[limit]=8&resources[options][unavailable_products]=last';
      fetch(url, { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(render)
        .catch(function () { results.innerHTML = ''; });
    }, 220);

    on(input, 'input', search);
  }
  /* ---------- cart: AJAX API + Section Rendering API ---------- */
  var cart = { item_count: 0, total_price: 0 };

  function updateCartCounters(count) {
    qsa('[data-ts-cart-count]').forEach(function (el) {
      el.textContent = count;
      if (count > 0) { el.removeAttribute('hidden'); } else { el.setAttribute('hidden', ''); }
    });
    qsa('[data-ts-cart-count-label]').forEach(function (el) {
      el.textContent = count + ' ' + (count === 1 ? 'ITEM' : 'ITEMS');
    });
  }

  function updateShippingMeters(total) {
    var threshold = CFG.freeShipping || 0;
    qsa('[data-ts-ship-progress]').forEach(function (bar) {
      var pct = threshold > 0 ? Math.min(100, Math.round((total / threshold) * 100)) : 100;
      bar.style.width = pct + '%';
    });
    qsa('[data-ts-ship-message]').forEach(function (msg) {
      var remaining = threshold - total;
      if (remaining > 0) {
        msg.textContent = (STR.shipRemainingPrefix || 'ADD ') + formatMoney(remaining) + (STR.shipRemainingSuffix || ' MORE FOR FREE SHIPPING');
      } else {
        msg.textContent = STR.shipUnlocked || 'FREE SHIPPING UNLOCKED. YOU WIN.';
      }
    });
  }

  function refreshCart(options) {
    options = options || {};
    var url = (CFG.cartUrl || '/cart') + '?section_id=main-cart';
    var requests = [
      fetch((CFG.cartUrl || '/cart') + '.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }),
      fetch(url).then(function (r) { return r.text(); })
    ];
    return Promise.all(requests).then(function (res) {
      cart = res[0] || cart;
      updateCartCounters(cart.item_count);
      updateShippingMeters(cart.total_price);
      var doc = new DOMParser().parseFromString(res[1], 'text/html');
      var source = doc.querySelector('[data-ts-cart-dynamic]');
      if (source) {
        qsa('[data-ts-cart-dynamic]').forEach(function (node) { node.innerHTML = source.innerHTML; });
        initQuantitySteppers();
      }
      if (options.open) { openCart(); }
      document.dispatchEvent(new CustomEvent('ts:cart-updated', { detail: cart }));
      return cart;
    }).catch(function () { return cart; });
  }

  function addToCart(body, openAfter) {
    var items = Array.isArray(body) ? { items: body } : body;
    return fetch((CFG.cartUrl || '/cart') + '/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(items)
    }).then(function (r) {
      return r.json().then(function (data) {
        if (!r.ok) { throw new Error(data.description || data.message || 'CART ERROR'); }
        return data;
      });
    }).then(function (data) {
      var shouldOpen = openAfter !== false && CFG.openCartDrawer !== false;
      return refreshCart({ open: shouldOpen }).then(function () { return data; });
    });
  }

  function changeCartLine(line, quantity) {
    return fetch((CFG.cartUrl || '/cart') + '/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ line: line, quantity: quantity })
    }).then(function (r) { return r.json(); }).then(function (data) {
      cart = data;
      return refreshCart();
    });
  }

  var drawer = null;
  var drawerUntrap = null;
  function openCart() {
    drawer = drawer || qs('[data-ts-drawer="cart"]');
    if (!drawer) { return; }
    drawer.setAttribute('data-open', 'true');
    lockScroll();
    var closeBtn = qs('[data-ts-drawer-close]', drawer);
    if (closeBtn && !reduced()) { closeBtn.focus(); }
    drawerUntrap = trapFocus(drawer);
  }
  function closeCart() {
    if (!drawer) { return; }
    drawer.setAttribute('data-open', 'false');
    unlockScroll();
    if (drawerUntrap) { drawerUntrap(); drawerUntrap = null; }
  }

  function initCartDrawer() {
    var drawerEl = qs('[data-ts-drawer="cart"]');
    if (!drawerEl) { return; }
    qsa('[data-ts-cart-open]').forEach(function (b) { on(b, 'click', function (e) { e.preventDefault(); refreshCart().then(openCart); }); });
    qsa('[data-ts-drawer-close]', drawerEl).forEach(function (b) { on(b, 'click', closeCart); });
    var scrim = qs('[data-ts-drawer-scrim]', drawerEl);
    on(scrim, 'click', closeCart);
    on(document, 'keydown', function (e) { if (e.key === 'Escape' && drawerEl.getAttribute('data-open') === 'true') { closeCart(); } });
  }
  /* ---------- quantity steppers ---------- */
  function initQuantitySteppers() {
    qsa('[data-ts-qty]').forEach(function (wrap) {
      if (wrap.getAttribute('data-ts-bound') === 'true') { return; }
      wrap.setAttribute('data-ts-bound', 'true');
      var input = qs('input', wrap);
      if (!input) { return; }
      qsa('[data-ts-qty-btn]', wrap).forEach(function (btn) {
        on(btn, 'click', function (e) {
          e.preventDefault();
          var step = btn.getAttribute('data-ts-qty-btn') === 'plus' ? 1 : -1;
          var min = parseInt(input.getAttribute('min') || '0', 10);
          var max = parseInt(input.getAttribute('max') || '9999', 10);
          var next = Math.min(max, Math.max(min, (parseInt(input.value, 10) || 0) + step));
          input.value = next;
          input.dispatchEvent(new Event('change', { bubbles: true }));
        });
      });
    });
  }

  function initCartLineActions() {
    document.addEventListener('click', function (e) {
      var removeBtn = e.target.closest('[data-ts-line-remove]');
      if (removeBtn) {
        e.preventDefault();
        var line = parseInt(removeBtn.getAttribute('data-ts-line-remove'), 10);
        var row = removeBtn.closest('.ts-line');
        if (row) { row.classList.add('ts-line--loading'); }
        changeCartLine(line, 0);
      }
    });
    document.addEventListener('change', function (e) {
      var qty = e.target.closest('[data-ts-line-qty]');
      if (qty) {
        var line = parseInt(qty.getAttribute('data-ts-line-qty'), 10);
        var row = qty.closest('.ts-line');
        if (row) { row.classList.add('ts-line--loading'); }
        changeCartLine(line, parseInt(qty.value, 10) || 0);
      }
      var note = e.target.closest('[data-ts-cart-note]');
      if (note) {
        fetch((CFG.cartUrl || '/cart') + '/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ note: note.value })
        }).catch(function () {});
      }
    });
  }
  /* ---------- product page: gallery, dots, plus -> select size ---------- */
  function initProduct() {
    var root = qs('[data-ts-product-main]');
    if (!root) { return; }

    var variants = [];
    try { variants = JSON.parse(root.getAttribute('data-ts-variants') || '[]'); } catch (err) { variants = []; }

    var priceEl = qs('[data-ts-price]', root);
    var compareEl = qs('[data-ts-compare]', root);
    var stockEl = qs('[data-ts-stock]', root);
    var waBtn = qs('[data-ts-wa]', root);
    var productTitle = root.getAttribute('data-product-title') || document.title;
    var productUrl = (root.getAttribute('data-product-url') || window.location.href).split('?')[0];
    var waNumber = root.getAttribute('data-wa-number') || '';
    var waTemplate = root.getAttribute('data-wa-template') || '';
    var lastPiecesLimit = parseInt(root.getAttribute('data-last-pieces') || '5', 10);

    /* ---- gallery: arrows, dots, swipe, smooth scroll-snap ---- */
    var track = qs('[data-ts-gallery-track]', root);
    var dots = qsa('[data-ts-dot]', root);
    var slides = track ? Array.prototype.slice.call(track.children) : [];
    var index = 0;

    function scrollBehaviour() { return reduced() ? 'auto' : 'smooth'; }

    function goTo(next, fromUser) {
      if (!track || !slides.length) { return; }
      index = Math.max(0, Math.min(slides.length - 1, next));
      track.scrollTo({ left: slides[index].offsetLeft, behavior: scrollBehaviour() });
      updateChrome();
      if (fromUser && slides[index]) {
        var img = qs('img', slides[index]);
        if (img && !reduced()) {
          img.animate([{ opacity: 0.55, transform: 'scale(.985)' }, { opacity: 1, transform: 'none' }],
            { duration: 420, easing: 'cubic-bezier(.22,.61,.36,1)' });
        }
      }
    }

    function updateChrome() {
      dots.forEach(function (dot, i) {
        dot.classList.toggle('is-active', i === index);
        if (i === index) { dot.setAttribute('aria-current', 'true'); } else { dot.removeAttribute('aria-current'); }
      });
      var prev = qs('[data-ts-gallery-prev]', root);
      var next = qs('[data-ts-gallery-next]', root);
      if (prev) { prev.toggleAttribute('disabled', index === 0); }
      if (next) { next.toggleAttribute('disabled', index === slides.length - 1); }
    }

    on(qs('[data-ts-gallery-prev]', root), 'click', function () { goTo(index - 1, true); });
    on(qs('[data-ts-gallery-next]', root), 'click', function () { goTo(index + 1, true); });
    dots.forEach(function (dot) {
      on(dot, 'click', function () { goTo(parseInt(dot.getAttribute('data-ts-dot'), 10), true); });
    });
    if (track && slides.length) {
      var onScroll = debounce(function () {
        var i = Math.round(track.scrollLeft / Math.max(1, track.clientWidth));
        if (i !== index) { index = i; updateChrome(); }
      }, 70);
      on(track, 'scroll', onScroll, { passive: true });
      on(window, 'resize', debounce(function () { goTo(index, false); }, 150));
      /* arrow keys when the gallery has focus */
      on(track, 'keydown', function (e) {
        if (e.key === 'ArrowLeft') { goTo(index - 1, true); }
        if (e.key === 'ArrowRight') { goTo(index + 1, true); }
      });
      updateChrome();
    }

    /* ---- "+" reveals SELECT SIZE, the garment eases up while it opens ---- */
    var sizePanel = qs('[data-ts-size-panel]', root);
    var plusBtn = qs('[data-ts-size-open]', root);
    var meta = qs('.ts-pdp__meta', root);

    function openSizes() {
      if (!sizePanel || !plusBtn) { return; }
      sizePanel.removeAttribute('hidden');
      plusBtn.setAttribute('aria-expanded', 'true');
      if (!reduced()) {
        sizePanel.animate(
          [{ opacity: 0, transform: 'translateY(10px)' }, { opacity: 1, transform: 'none' }],
          { duration: 320, easing: 'cubic-bezier(.22,.61,.36,1)', fill: 'backwards' }
        );
        var stage = qs('[data-ts-gallery]', root);
        if (stage) {
          stage.animate(
            [{ transform: 'none' }, { transform: 'scale(.94) translateY(-14px)' }],
            { duration: 420, easing: 'cubic-bezier(.22,.61,.36,1)', fill: 'forwards' }
          );
        }
        var dotsEl = qs('[data-ts-gallery-dots]', root);
        if (dotsEl) {
          dotsEl.animate([{ opacity: 1 }, { opacity: 0 }], { duration: 250, fill: 'forwards' });
        }
      }
      if (meta) { meta.scrollIntoView({ behavior: scrollBehaviour(), block: 'nearest' }); }
      var first = qs('.ts-pdp__size:not([disabled])', sizePanel);
      if (first && !reduced()) { first.focus({ preventScroll: true }); }
    }

    function closeSizes() {
      if (!sizePanel || !plusBtn) { return; }
      sizePanel.setAttribute('hidden', '');
      plusBtn.setAttribute('aria-expanded', 'false');
      var stage = qs('[data-ts-gallery]', root);
      if (stage && !reduced()) {
        stage.animate([{ transform: 'scale(.94) translateY(-14px)' }, { transform: 'none' }],
          { duration: 380, easing: 'cubic-bezier(.22,.61,.36,1)' });
      }
      var dotsEl = qs('[data-ts-gallery-dots]', root);
      if (dotsEl) { dotsEl.animate([{ opacity: 0 }, { opacity: 1 }], { duration: 260 }); }
      if (plusBtn && !reduced()) { plusBtn.focus({ preventScroll: true }); }
    }

    on(plusBtn, 'click', openSizes);
    on(qs('[data-ts-size-close]', root), 'click', closeSizes);
    on(document, 'keydown', function (e) {
      if (e.key === 'Escape' && sizePanel && !sizePanel.hasAttribute('hidden')) { closeSizes(); }
    });

    /* ---- price / stock / whatsapp reflect the chosen variant ---- */
    function applyVariant(variant) {
      if (!variant) { return; }
      if (priceEl) { priceEl.textContent = formatMoney(variant.price); }
      if (compareEl) {
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          compareEl.innerHTML = '<s>' + formatMoney(variant.compare_at_price) + '</s>';
          compareEl.removeAttribute('hidden');
        } else { compareEl.setAttribute('hidden', ''); }
      }
      if (stockEl) {
        if (!variant.available) {
          stockEl.textContent = STR.soldOut || 'SOLD OUT';
          stockEl.removeAttribute('hidden');
        } else if (variant.inventory_management && variant.inventory_quantity > 0 && variant.inventory_quantity <= lastPiecesLimit) {
          stockEl.textContent = (STR.lastPieces || 'LAST PIECES') + ' — ' + variant.inventory_quantity + ' LEFT';
          stockEl.removeAttribute('hidden');
        } else { stockEl.setAttribute('hidden', ''); }
      }
      if (waBtn) {
        waBtn.setAttribute('href', whatsappLink(waTemplate, {
          product: productTitle,
          variant: variant.title,
          url: productUrl + '?variant=' + variant.id,
          price: formatMoney(variant.price),
          number: waNumber
        }));
      }
      if (variant.media_position) { goTo(variant.media_position - 1, false); }
      try { window.history.replaceState({}, '', window.location.pathname + '?variant=' + variant.id); } catch (err) { /* noop */ }
    }

    /* ---- tapping a size adds it straight to the bag ---- */
    document.addEventListener('click', function (e) {
      var sizeBtn = e.target.closest('[data-ts-size-add]');
      if (!sizeBtn || !root.contains(sizeBtn)) { return; }
      e.preventDefault();
      if (sizeBtn.getAttribute('aria-disabled') === 'true') { return; }
      var id = parseInt(sizeBtn.getAttribute('data-ts-size-add'), 10);
      var variant = null;
      for (var i = 0; i < variants.length; i += 1) { if (variants[i].id === id) { variant = variants[i]; } }
      sizeBtn.classList.add('is-adding');
      var label = sizeBtn.textContent;
      addToCart({ id: id, quantity: 1 }).then(function () {
        if (variant) { applyVariant(variant); }
        sizeBtn.textContent = STR.added || 'ADDED';
        if (!reduced()) {
          sizeBtn.animate([{ transform: 'scale(1)' }, { transform: 'scale(.96)' }, { transform: 'scale(1)' }],
            { duration: 260, easing: 'ease-out' });
        }
        setTimeout(function () { sizeBtn.textContent = label; sizeBtn.classList.remove('is-adding'); }, 1400);
      }).catch(function () {
        sizeBtn.textContent = STR.error || 'TRY AGAIN';
        setTimeout(function () { sizeBtn.textContent = label; sizeBtn.classList.remove('is-adding'); }, 1400);
      });
    });

    /* ---- single-variant products add straight from the page ---- */
    on(qs('[data-ts-quick-add]', root), 'click', function (e) {
      e.preventDefault();
      var btn = e.currentTarget;
      var id = parseInt(btn.getAttribute('data-ts-quick-add'), 10);
      btn.setAttribute('aria-disabled', 'true');
      var label = btn.textContent;
      btn.textContent = STR.adding || 'ADDING...';
      addToCart({ id: id, quantity: 1 }).then(function () {
        btn.textContent = STR.added || 'ADDED';
        setTimeout(function () { btn.textContent = label; btn.removeAttribute('aria-disabled'); }, 1500);
      }).catch(function () {
        btn.textContent = STR.error || 'TRY AGAIN';
        setTimeout(function () { btn.textContent = label; btn.removeAttribute('aria-disabled'); }, 1500);
      });
    });

    /* ---- zoom ---- */
    var zoom = qs('[data-ts-zoom]', root);
    qsa('[data-ts-zoom-open]', root).forEach(function (btn) {
      on(btn, 'click', function () {
        if (!zoom) { return; }
        var src = btn.getAttribute('data-zoom-src');
        var target = qs('img', zoom);
        if (src && target) { target.src = src; }
        zoom.setAttribute('data-open', 'true');
        lockScroll();
        var c = qs('[data-ts-zoom-close]', zoom);
        if (c) { c.focus(); }
      });
    });
    if (zoom) {
      qsa('[data-ts-zoom-close]', zoom).forEach(function (b) {
        on(b, 'click', function () { zoom.setAttribute('data-open', 'false'); unlockScroll(); });
      });
      on(document, 'keydown', function (e) {
        if (e.key === 'Escape' && zoom.getAttribute('data-open') === 'true') { zoom.setAttribute('data-open', 'false'); unlockScroll(); }
      });
    }

    /* ---- size guide modal ---- */
    qsa('[data-ts-modal-open]').forEach(function (b) {
      on(b, 'click', function () {
        var modal = qs('[data-ts-modal="' + b.getAttribute('data-ts-modal-open') + '"]');
        if (!modal) { return; }
        modal.setAttribute('data-open', 'true');
        lockScroll();
        var c = qs('[data-ts-modal-close]', modal);
        if (c) { c.focus(); }
      });
    });
    qsa('[data-ts-modal]').forEach(function (m) {
      qsa('[data-ts-modal-close]', m).forEach(function (b) {
        on(b, 'click', function () { m.setAttribute('data-open', 'false'); unlockScroll(); });
      });
      on(m, 'click', function (e) { if (e.target === m) { m.setAttribute('data-open', 'false'); unlockScroll(); } });
    });
    on(document, 'keydown', function (e) {
      if (e.key !== 'Escape') { return; }
      qsa('[data-ts-modal][data-open="true"]').forEach(function (m) { m.setAttribute('data-open', 'false'); unlockScroll(); });
    });
  }

  /* ---------- soft entrance: tiles and hero fade in, capped and staggered ---------- */
  function initEntrance() {
    if (reduced()) { return; }
    qsa('.ts-grid').forEach(function (grid) {
      var tiles = Array.prototype.slice.call(grid.children);
      tiles.forEach(function (tile, i) {
        if (i > 11) { return; }
        tile.animate(
          [{ opacity: 0, transform: 'translateY(10px) scale(.99)' }, { opacity: 1, transform: 'none' }],
          { duration: 480, delay: i * 45, easing: 'cubic-bezier(.22,.61,.36,1)', fill: 'backwards' }
        );
      });
    });
    var stage = qs('.ts-pdp__stage');
    if (stage) {
      stage.animate([{ opacity: 0, transform: 'scale(.985)' }, { opacity: 1, transform: 'none' }],
        { duration: 520, easing: 'cubic-bezier(.22,.61,.36,1)' });
    }
    var meta = qs('.ts-pdp__meta');
    if (meta) {
      meta.animate([{ opacity: 0, transform: 'translateY(8px)' }, { opacity: 1, transform: 'none' }],
        { duration: 480, delay: 90, easing: 'cubic-bezier(.22,.61,.36,1)', fill: 'backwards' });
    }
  }

  /* ---------- back arrow uses history when it can, the link otherwise ---------- */
  function initBack() {
    on(qs('[data-ts-back]'), 'click', function (e) {
      if (window.history.length > 1 && document.referrer.indexOf(window.location.host) !== -1) {
        e.preventDefault();
        window.history.back();
      }
    });
  }

  /* ---------- countdown (multiple instances per page) ---------- */
  function initCountdowns() {
    qsa('[data-ts-countdown]').forEach(function (root) {
      var dateStr = root.getAttribute('data-date');
      if (!dateStr) { return; }
      var target = new Date(dateStr).getTime();
      if (isNaN(target)) { return; }
      var digits = qs('[data-ts-cd-digits]', root);
      var live = qs('[data-ts-cd-live]', root);
      var cells = {
        days: qs('[data-ts-cd-days]', root),
        hours: qs('[data-ts-cd-hours]', root),
        minutes: qs('[data-ts-cd-minutes]', root),
        seconds: qs('[data-ts-cd-seconds]', root)
      };
      function pad(n) { return String(Math.max(0, n)).padStart(2, '0'); }
      function tick() {
        var diff = target - Date.now();
        if (diff <= 0) {
          if (digits) { digits.setAttribute('hidden', ''); }
          if (live) { live.removeAttribute('hidden'); }
          clearInterval(timer);
          return;
        }
        var d = Math.floor(diff / 86400000);
        var h = Math.floor((diff % 86400000) / 3600000);
        var m = Math.floor((diff % 3600000) / 60000);
        var s = Math.floor((diff % 60000) / 1000);
        if (cells.days) { cells.days.textContent = pad(d); }
        if (cells.hours) { cells.hours.textContent = pad(h); }
        if (cells.minutes) { cells.minutes.textContent = pad(m); }
        if (cells.seconds) { cells.seconds.textContent = pad(s); }
      }
      var timer = setInterval(tick, 1000);
      tick();
    });
  }
  /* ---------- lookbook: drag to scroll + progress ---------- */
  function initLookbook() {
    qsa('[data-ts-lookbook]').forEach(function (root) {
      var rail = qs('[data-ts-lookbook-rail]', root);
      var bar = qs('[data-ts-lookbook-bar] span', root);
      if (!rail) { return; }
      var isDown = false, startX = 0, startLeft = 0, moved = false;
      on(rail, 'pointerdown', function (e) {
        if (e.pointerType === 'touch') { return; }
        isDown = true; moved = false;
        startX = e.clientX; startLeft = rail.scrollLeft;
        rail.classList.add('ts-dragging');
      });
      on(window, 'pointermove', function (e) {
        if (!isDown) { return; }
        var delta = e.clientX - startX;
        if (Math.abs(delta) > 4) { moved = true; }
        rail.scrollLeft = startLeft - delta;
      });
      on(window, 'pointerup', function () {
        if (!isDown) { return; }
        isDown = false;
        rail.classList.remove('ts-dragging');
      });
      on(rail, 'click', function (e) { if (moved) { e.preventDefault(); } }, true);
      function progress() {
        if (!bar) { return; }
        var max = rail.scrollWidth - rail.clientWidth;
        var pct = max > 0 ? (rail.scrollLeft / max) * 100 : 0;
        bar.style.width = Math.max(8, pct) + '%';
      }
      on(rail, 'scroll', progress, { passive: true });
      on(window, 'resize', progress);
      progress();
    });
  }
  /* ---------- collection: filters, sort, load more ---------- */
  function initCollection() {
    var root = qs('[data-ts-collection]');
    if (!root) { return; }
    var facets = qs('[data-ts-facets]', root);

    function currentForm() { return qs('[data-ts-facets-form]', root); }

    function buildUrl() {
      var form = currentForm();
      if (!form) { return null; }
      var params = new URLSearchParams();
      new FormData(form).forEach(function (value, key) {
        if (value !== '' && value !== null) { params.append(key, value); }
      });
      var sort = qs('[data-ts-sort]', root);
      if (sort && sort.value) { params.set('sort_by', sort.value); }
      return window.location.pathname + '?' + params.toString();
    }

    function swap(url) {
      var target = qs('[data-ts-collection-results]', root);
      if (!target) { window.location.href = url; return; }
      var sep = url.indexOf('?') === -1 ? '?' : '&';
      fetch(url + sep + 'section_id=main-collection')
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var fresh = doc.querySelector('[data-ts-collection-results]');
          if (!fresh) { window.location.href = url; return; }
          target.innerHTML = fresh.innerHTML;
          var freshCount = doc.querySelector('[data-ts-collection-count]');
          var countEl = qs('[data-ts-collection-count]', root);
          if (freshCount && countEl) { countEl.innerHTML = freshCount.innerHTML; }
          qsa('[data-ts-collection-active]').forEach(function (node, i) {
            var freshNode = doc.querySelectorAll('[data-ts-collection-active]')[i];
            if (freshNode) { node.innerHTML = freshNode.innerHTML; }
          });
          initProductCards();
          bindLoadMore();
          try { window.history.pushState({}, '', url); } catch (err) { /* noop */ }

          if (!reduced()) { window.scrollTo({ top: root.offsetTop - 80, behavior: 'smooth' }); }
        })
        .catch(function () { window.location.href = url; });
    }

    on(root, 'change', function (e) {
      var target = e.target;
      if (target.closest('[data-ts-facets-form]') || target.matches('[data-ts-sort]')) {
        var url = buildUrl();
        if (url) { swap(url); }
      }
    });
    on(root, 'click', function (e) {
      if (e.target.closest('[data-ts-filter-clear]') || e.target.closest('[data-ts-filter-close]')) {
        e.preventDefault();
        var clear = e.target.closest('[data-ts-filter-clear]');
        if (clear && facets) {
          qsa('input[type="checkbox"]', facets).forEach(function (i) { i.checked = false; });
          qsa('input[type="number"]', facets).forEach(function (i) { i.value = ''; });
          var url2 = buildUrl();
          if (url2) { swap(url2); }
        }
        if (facets) { facets.setAttribute('data-open', 'false'); }
      }
    });

    /* mobile filter drawer */
    var openBtn = qs('[data-ts-filter-open]', root);
    if (openBtn && facets) {
      on(openBtn, 'click', function () {
        facets.setAttribute('data-open', 'true');
        lockScroll();
      });
      on(qs('[data-ts-filter-cancel]', facets), 'click', function () {
        facets.setAttribute('data-open', 'false');
        unlockScroll();
      });
    }

    /* load more */
    function bindLoadMore() {
      qsa('[data-ts-load-more]').forEach(function (btn) {
        if (btn.getAttribute('data-ts-bound') === 'true') { return; }
        btn.setAttribute('data-ts-bound', 'true');
        on(btn, 'click', function () {
          var url = btn.getAttribute('data-ts-load-more');
          if (!url) { return; }
          btn.textContent = STR.loading || 'LOADING...';
          var sep = url.indexOf('?') === -1 ? '?' : '&';
          fetch(url + sep + 'section_id=main-collection')
            .then(function (r) { return r.text(); })
            .then(function (html) {
              var doc = new DOMParser().parseFromString(html, 'text/html');
              var grid = qs('[data-ts-grid]');
              var freshGrid = doc.querySelector('[data-ts-grid]');
              if (grid && freshGrid) {
                Array.prototype.slice.call(freshGrid.children).forEach(function (child) { grid.appendChild(child); });
              }
              var nextBtn = doc.querySelector('[data-ts-load-more]');
              var next = nextBtn ? nextBtn.getAttribute('data-ts-load-more') : '';
              if (next) { btn.setAttribute('data-ts-load-more', next); btn.textContent = STR.loadMore || 'LOAD MORE'; }
              else { btn.remove(); }
              initProductCards();
            })
            .catch(function () { btn.textContent = STR.error || 'TRY AGAIN'; });
        });
      });
    }
    bindLoadMore();
    window.TS.bindLoadMore = bindLoadMore;
  }
  /* ---------- newsletter popup ---------- */
  function initPopup() {
    var popup = qs('[data-ts-popup]');
    if (!popup || popup.getAttribute('data-disabled') === 'true') { return; }
    var key = 'ts_popup_seen_v1';
    var storage = null;
    try { storage = window.localStorage; } catch (err) { storage = null; }
    if (storage) {
      try { if (storage.getItem(key) === '1') { return; } } catch (err) { /* noop */ }
    }
    var delay = parseInt(popup.getAttribute('data-delay') || '6', 10) * 1000;
    var untrap = null;
    function open() {
      popup.removeAttribute('hidden');
      lockScroll();
      var field = qs('input[type="email"]', popup);
      if (field) { field.focus(); }
      untrap = trapFocus(popup);
    }
    function close() {
      popup.setAttribute('hidden', '');
      unlockScroll();
      if (untrap) { untrap(); untrap = null; }
      if (storage) { try { storage.setItem(key, '1'); } catch (err) { /* noop */ } }
    }
    window.setTimeout(open, isNaN(delay) ? 6000 : delay);
    qsa('[data-ts-popup-close]', popup).forEach(function (b) { on(b, 'click', close); });
    on(document, 'keydown', function (e) { if (e.key === 'Escape' && !popup.hasAttribute('hidden')) { close(); } });

    var form = qs('form', popup);
    function handleSubmit(e) {
      e.preventDefault();
      var email = qs('input[type="email"]', popup);
      var status = qs('[data-ts-popup-status]', popup);
      if (!email || !isEmail(email.value)) {
        if (status) { status.textContent = STR.badEmail || 'CHECK THE EMAIL AND TRY AGAIN.'; }
        if (email) { email.focus(); }
        return;
      }
      fetch(form.action, { method: 'POST', body: new FormData(form), headers: { Accept: 'text/html' } })
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var failed = html.indexOf('ts-errors') !== -1;
          if (status) {
            status.textContent = failed
              ? (STR.badEmail || 'CHECK THE EMAIL AND TRY AGAIN.')
              : (popup.getAttribute('data-success') || "YOU'RE IN. WATCH YOUR INBOX.");
            if (!failed) { status.classList.add('ts-form--success'); }
          }
          if (failed) { return; }
          form.setAttribute('hidden', '');
          if (storage) { try { storage.setItem(key, '1'); } catch (err) { /* noop */ } }
          window.setTimeout(close, 2200);
        })
        .catch(function () {
          // no AJAX — let the browser submit natively
          form.removeEventListener('submit', handleSubmit);
          form.submit();
        });
    }
    if (form) { on(form, 'submit', handleSubmit); }
  }
  /* ---------- accordions: aria-expanded sync ---------- */
  function initAccordions() {
    qsa('[data-ts-acc]').forEach(function (details) {
      var summary = qs('summary', details);
      if (!summary || summary.getAttribute('data-ts-bound') === 'true') { return; }
      summary.setAttribute('data-ts-bound', 'true');
      summary.setAttribute('aria-expanded', details.open ? 'true' : 'false');
      details.addEventListener('toggle', function () {
        summary.setAttribute('aria-expanded', details.open ? 'true' : 'false');
      });
    });
  }
  /* ---------- product recommendations (Shopify API) ---------- */
  function initRecommendations() {
    qsa('[data-ts-recs-url]').forEach(function (root) {
      if (root.getAttribute('data-ts-bound') === 'true') { return; }
      root.setAttribute('data-ts-bound', 'true');
      fetch(root.getAttribute('data-ts-recs-url'))
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var fresh = doc.querySelector('[data-ts-recs-inner]');
          if (fresh) { root.innerHTML = fresh.innerHTML; }
        })
        .catch(function () {});
    });
  }
  /* ---------- public API + boot ---------- */
  TS.addToCart = addToCart;
  TS.refreshCart = refreshCart;
  TS.openCart = openCart;
  TS.closeCart = closeCart;

  function boot() {
    initHeaderScroll();
    initMobileMenu();
    initSearch();
    initCartDrawer();
    initQuantitySteppers();
    initCartLineActions();
    initProductCards();
    initProduct();
    initCountdowns();
    initLookbook();
    initCollection();
    initPopup();
    initAccordions();
    initRecommendations();
    initEntrance();
    initBack();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
